import { Button } from "@/components/Buttons";
import { BirthdayField, HiddenField, PasswordField, RadioField, ReadOnlyField, SingleCheckboxField, TextField } from "@/components/Form/Parts/index";
import { useAdultModeQuery, useSignupQuery } from "@/hooks";
import yupAgeValidate from "@/lib/yupAgeValidate";
import yupPasswordValidate from "@/lib/yupPasswordValidate";
import formStyles from "@/styles/Form.module.scss";
import processStyles from "@/styles/Process.module.scss";
import { yupResolver } from "@hookform/resolvers/yup";
import classnames from "classnames";
import Link from "next/link";
import { useState, useMemo, useCallback } from "react";
import { useForm } from "react-hook-form";
import * as y from "yup";
import ErrorMessage from "../Parts/ErrorMessage";
import RecommendArticleForm from "../RecommendArticleForm";
import { GENDER_LABEL, ADULT_RESTRICTION_AGE } from "@/lib/constants";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
yupAgeValidate(y);
yupPasswordValidate(y);
var schema = y.object().shape({
  lastName: y.string().max(10, "10文字以内で入力してください。").required("お名前(姓)を入力してください。"),
  firstName: y.string().max(10, "10文字以内で入力してください。").required("お名前(名)を入力してください。"),
  sex: y.string().required("性別を選択してください。"),
  birthday: y.string().matches(/^\d{4}-\d{2}-\d{2}$/, "生年月日が正しくありません。").age(ADULT_RESTRICTION_AGE).required("生年月日を選択してください。"),
  password: y.string().min(8, "パスワードは8文字以上で入力してください。").passwordFormat().required("パスワードが入力されていません。"),
  terms: y.boolean().oneOf([true], "規約に同意してください。")
});
export default function Step3(_ref) {
  var _errors$lastName, _errors$firstName, _errors$sex, _errors$birthday, _errors$password, _errors$termsAd, _errors$terms_mail, _errors$terms;

  var formData = _ref.formData,
      error = _ref.error,
      onSubmit = _ref.onSubmit,
      submited = _ref.submited;

  var _useAdultModeQuery = useAdultModeQuery({
    fetchPolicy: "cache-first"
  }),
      adultMode = _useAdultModeQuery.data.adultMode;

  var _useForm = useForm({
    resolver: yupResolver(schema),
    mode: "all"
  }),
      formState = _useForm.formState,
      register = _useForm.register,
      setValue = _useForm.setValue,
      handleSubmit = _useForm.handleSubmit,
      errors = _useForm.errors;

  var isDirty = formState.isDirty,
      isValid = formState.isValid,
      isSubmitting = formState.isSubmitting;

  var _useSignupQuery = useSignupQuery({
    variables: {
      adult: adultMode
    }
  }),
      data = _useSignupQuery.data;

  var _ref2 = data !== null && data !== void 0 ? data : {},
      requiredTerms = _ref2.requiredTerms,
      optionalTerms = _ref2.optionalTerms,
      recommendArticle = _ref2.recommendArticle;

  var _ref3 = recommendArticle !== null && recommendArticle !== void 0 ? recommendArticle : {},
      courses = _ref3.courses,
      products = _ref3.products;

  var hasRecommendArticle = courses || products;

  var _useState = useState(),
      recommend = _useState[0],
      setRecommend = _useState[1];

  var relayOnSubmit = useCallback(function (data) {
    onSubmit(data, recommend);
  }, [recommend, onSubmit]);
  var terms = useMemo(function () {
    if (requiredTerms) {
      var links = requiredTerms.map(function (term) {
        return /*#__PURE__*/_jsx(Link, {
          href: term.current_revision.url,
          children: /*#__PURE__*/_jsx("a", {
            target: "_blank",
            rel: "noopener noreferrer",
            children: term.display_name
          })
        }, term.id_key);
      });
      var value = requiredTerms.map(function (term) {
        return term.current_revision.unique_key;
      });
      return {
        links: links,
        value: value
      };
    } else {
      return {};
    }
  }, [requiredTerms]);
  var adTerm = useMemo(function () {
    if (optionalTerms) {
      var term = optionalTerms.find(function (term) {
        return term.id_key === "ad";
      });

      if (term) {
        return {
          link: term.current_revision.url,
          value: term.current_revision.unique_key
        };
      }
    }

    return null;
  }, [optionalTerms]);
  var mailTerm = useMemo(function () {
    if (optionalTerms) {
      var key = adultMode ? "spoox_mail_adult" : "spoox_mail";
      var term = optionalTerms.find(function (term) {
        return term.id_key === key;
      });

      if (term) {
        return {
          link: term.current_revision.url,
          value: term.current_revision.unique_key
        };
      }
    }

    return null;
  }, [adultMode, optionalTerms]);
  return /*#__PURE__*/_jsxs("form", {
    onSubmit: handleSubmit(relayOnSubmit),
    noValidate: true,
    children: [/*#__PURE__*/_jsx("div", {
      className: processStyles.contentWrapper,
      children: /*#__PURE__*/_jsxs("div", {
        className: processStyles.content,
        children: [/*#__PURE__*/_jsx("fieldset", {
          className: "".concat(formStyles.basicFieldset, " ").concat(formStyles.marginOff),
          children: /*#__PURE__*/_jsxs("div", {
            className: formStyles.inputField,
            children: [/*#__PURE__*/_jsx("legend", {
              className: classnames(formStyles.formTitle, formStyles.required),
              children: "\u540D\u524D"
            }), /*#__PURE__*/_jsxs("div", {
              className: formStyles.formGroup,
              children: [/*#__PURE__*/_jsx(TextField, {
                ref: register,
                name: "lastName",
                placeholder: "\u59D3\u3092\u5165\u529B",
                error: (_errors$lastName = errors.lastName) === null || _errors$lastName === void 0 ? void 0 : _errors$lastName.message,
                autoComplete: "family-name",
                required: true
              }), /*#__PURE__*/_jsx(TextField, {
                ref: register,
                name: "firstName",
                placeholder: "\u540D\u3092\u5165\u529B",
                error: (_errors$firstName = errors.firstName) === null || _errors$firstName === void 0 ? void 0 : _errors$firstName.message,
                autoComplete: "given-name",
                required: true
              })]
            })]
          })
        }), /*#__PURE__*/_jsx("fieldset", {
          className: formStyles.basicFieldset,
          children: /*#__PURE__*/_jsx(RadioField, {
            ref: register,
            title: "\u6027\u5225",
            name: "sex",
            options: [{
              value: "man",
              label: GENDER_LABEL[1],
              order: 1
            }, {
              value: "woman",
              label: GENDER_LABEL[2],
              order: 2
            }, {
              value: "unknown",
              label: GENDER_LABEL[0],
              order: 3
            }],
            error: (_errors$sex = errors.sex) === null || _errors$sex === void 0 ? void 0 : _errors$sex.message,
            required: true
          })
        }), /*#__PURE__*/_jsx("fieldset", {
          className: formStyles.basicFieldset,
          children: /*#__PURE__*/_jsx(BirthdayField, {
            ref: register,
            name: "birthday",
            title: "\u751F\u5E74\u6708\u65E5",
            error: (_errors$birthday = errors.birthday) === null || _errors$birthday === void 0 ? void 0 : _errors$birthday.message,
            setValue: setValue,
            required: true
          })
        }), /*#__PURE__*/_jsx("fieldset", {
          className: formStyles.basicFieldset,
          children: /*#__PURE__*/_jsx(ReadOnlyField, {
            title: "E\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\uFF08\u30ED\u30B0\u30A4\u30F3ID\uFF09",
            value: formData.mailAddress
          })
        }), /*#__PURE__*/_jsxs("fieldset", {
          className: formStyles.basicFieldset,
          children: [/*#__PURE__*/_jsx("input", {
            type: "email",
            name: "email",
            style: {
              display: "none"
            },
            value: formData.mailAddress,
            autoComplete: "username"
          }), /*#__PURE__*/_jsx(PasswordField, {
            ref: register,
            title: "\u30D1\u30B9\u30EF\u30FC\u30C9",
            captionTop: "\u203B\u30A2\u30EB\u30D5\u30A1\u30D9\u30C3\u30C8\u3001\u6570\u5B57\u3001\u8A18\u53F7\uFF08!@$#%+-_\uFF09\u3092\u7D44\u307F\u5408\u308F\u305B\u305F8\u6587\u5B57\u4EE5\u4E0A\u3067\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
            name: "password",
            autoComplete: "new-password",
            error: (_errors$password = errors.password) === null || _errors$password === void 0 ? void 0 : _errors$password.message,
            required: true
          })]
        }), adTerm && /*#__PURE__*/_jsxs("fieldset", {
          className: formStyles.basicFieldset,
          children: [/*#__PURE__*/_jsx(SingleCheckboxField, {
            ref: register,
            title: "\u5E83\u544A\u306B\u304A\u3051\u308B\u30C7\u30FC\u30BF\u5229\u7528\u306B\u3064\u3044\u3066\u306E\u78BA\u8A8D\u3068\u540C\u610F",
            name: "termsAd",
            defaultChecked: false,
            label: /*#__PURE__*/_jsxs("p", {
              className: formStyles.terms,
              children: ["\u672C\u30B5\u30FC\u30D3\u30B9\u3067\u306F\u5229\u7528\u8005\u306B\u540C\u610F\u3044\u305F\u3060\u3044\u305F\u4E0A\u3067\u30B5\u30FC\u30D3\u30B9\u306E\u5229\u7528\u60C5\u5831\u3092\u53CE\u96C6\u3057\u3001\u5E83\u544A\u914D\u4FE1\u306A\u3069\u306B\u6D3B\u7528\u3057\u3066\u3044\u307E\u3059\u3002", " ", /*#__PURE__*/_jsx(Link, {
                href: adTerm.link,
                children: /*#__PURE__*/_jsx("a", {
                  target: "_blank",
                  rel: "noopener noreferrer",
                  children: "\u5E83\u544A\u306B\u304A\u3051\u308B\u30C7\u30FC\u30BF\u5229\u7528"
                })
              }), "\u3092\u78BA\u8A8D\u306E\u4E0A\u3001\u540C\u610F\u3059\u308B"]
            }),
            error: (_errors$termsAd = errors.termsAd) === null || _errors$termsAd === void 0 ? void 0 : _errors$termsAd.message
          }), /*#__PURE__*/_jsx(HiddenField, {
            ref: register,
            name: "termsAdValue",
            defaultValue: adTerm.value
          })]
        }), mailTerm && /*#__PURE__*/_jsxs("fieldset", {
          className: formStyles.basicFieldset,
          children: [/*#__PURE__*/_jsx(SingleCheckboxField, {
            ref: register,
            title: "\u3054\u6848\u5185\u30E1\u30FC\u30EB\u3078\u306E\u540C\u610F",
            name: "termsMail",
            defaultChecked: false,
            label: /*#__PURE__*/_jsxs("p", {
              className: formStyles.terms,
              children: ["\u672C\u30B5\u30FC\u30D3\u30B9\u304B\u3089\u306E\u3054\u6848\u5185\u30E1\u30FC\u30EB\u306E\u9001\u4ED8\u306B\u540C\u610F\u3059\u308B(\u8A73\u7D30\u306F", /*#__PURE__*/_jsx(Link, {
                href: mailTerm.link,
                children: /*#__PURE__*/_jsx("a", {
                  target: "_blank",
                  rel: "noopener noreferrer",
                  children: "\u3053\u3061\u3089"
                })
              }), ")"]
            }),
            error: (_errors$terms_mail = errors.terms_mail) === null || _errors$terms_mail === void 0 ? void 0 : _errors$terms_mail.message
          }), /*#__PURE__*/_jsx(HiddenField, {
            ref: register,
            name: "termsMailValue",
            defaultValue: mailTerm.value
          })]
        }), /*#__PURE__*/_jsxs("fieldset", {
          className: formStyles.basicFieldset,
          children: [/*#__PURE__*/_jsx(SingleCheckboxField, {
            ref: register,
            title: "\u898F\u7D04\u306E\u78BA\u8A8D\u3068\u540C\u610F",
            name: "terms",
            defaultChecked: false,
            label: /*#__PURE__*/_jsxs("p", {
              className: formStyles.terms,
              children: [terms.links, "\u3092\u78BA\u8A8D\u306E\u4E0A\u3001\u540C\u610F\u3059\u308B"]
            }),
            error: (_errors$terms = errors.terms) === null || _errors$terms === void 0 ? void 0 : _errors$terms.message,
            required: true
          }), /*#__PURE__*/_jsx(HiddenField, {
            ref: register,
            name: "termsValue",
            defaultValue: terms.value
          })]
        })]
      })
    }), error && /*#__PURE__*/_jsx(ErrorMessage, {
      msg: error === null || error === void 0 ? void 0 : error.message
    }), /*#__PURE__*/_jsx(RecommendArticleForm, {
      recommendArticle: recommendArticle,
      onChange: setRecommend
    }), /*#__PURE__*/_jsx("div", {
      className: formStyles.btnArea,
      children: /*#__PURE__*/_jsxs(Button, {
        type: "submit",
        fillColor: true,
        large: true,
        fontFixed: true,
        disabled: !isDirty || !isValid,
        disabledWithGray: true,
        loading: submited || isSubmitting,
        children: [!hasRecommendArticle && "会員登録する", hasRecommendArticle && "会員登録完了し、購入手続きへ"]
      })
    })]
  });
}